import React from 'react';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
import { HERO_MOCKUP } from '../data/content';
export function Hero() {
  return <header className="w-full bg-cream px-4 pb-12 pt-7 sm:px-6 sm:pt-10" data-id="element-177" data-mp="9k0h1ej88rst">
      <div className="mx-auto max-w-5xl" data-id="element-178" data-mp="4lyuukqi8cd4">
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center" data-id="element-179" data-mp="4n1j0kwg00pc">
          <span className="flex items-center gap-2 font-display text-lg font-bold text-brand-700" data-id="element-180" data-mp="128fo9ew4a5tl">
            <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-700 text-base" aria-hidden="true" data-id="element-181" data-mp="xbfi73z9p32h">
              🦷
            </span>
            Dra. Karito
          </span>
          <span className="rounded-full border border-brand-200 bg-white px-3 py-1.5 text-[10.5px] font-extrabold uppercase tracking-[0.1em] text-brand-700" data-id="element-182" data-mp="nekmstyajisf">
            The Natural Veneer Blueprint™
          </span>
        </div>

        <h1 className="mt-7 text-center font-display text-[30px] font-bold leading-[1.12] tracking-tight text-ink sm:text-5xl lg:text-6xl" data-id="element-183" data-mp="3j7zgtn69y0is">
          Analyze &amp; plan resin veneers{' '}
          <em className="italic text-brand-600" data-id="element-184" data-mp="39al9qe68qo35">in under 15 minutes</em>
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-[15.5px] leading-relaxed text-brand-900/75 sm:text-lg" data-id="element-185" data-mp="3e9frrdwdw8m7">
          A visual step-by-step system that helps you evaluate anatomy, color, layering, texture,
          and finishing <strong className="font-bold text-ink" data-id="element-186" data-mp="358zpu8vah9jg">before you start</strong> — so you
          can stop guessing and know exactly what to look for at every stage.
        </p>

        <p className="mx-auto mt-4 max-w-2xl text-center text-[14.5px] leading-relaxed text-brand-900/70 sm:text-base" data-id="element-187" data-mp="2viy43nqes37p">
          Includes <strong className="font-bold text-ink" data-id="element-188" data-mp="2hix1o3uhwnq4">8 Visual Blueprints</strong>,{' '}
          <strong className="font-bold text-ink" data-id="element-189" data-mp="2lla5untlgdks">6 Professional Tools</strong>, and{' '}
          <strong className="font-bold text-ink" data-id="element-190" data-mp="s1rpyhl8dur4">40+ Checklists</strong>, Decision Maps &amp;
          Clinical References.
        </p>

        <figure className="mt-8" data-id="element-191" data-mp="na9z4mcx9ajv">
          <img src={HERO_MOCKUP} alt="The Natural Veneer Blueprint bundle: 8 blueprint volumes, 6 bonuses, worksheets and digital tools" className="mx-auto w-full max-w-3xl" width={1280} height={1280} data-id="element-192" data-mp="n98cdkmjmzmb" />
          <figcaption className="mt-2 text-center text-[12px] font-semibold uppercase tracking-[0.08em] text-brand-800/60" data-id="element-193" data-mp="1azkwdtv2cmt9">
            The 8 Blueprints + 5 Bonuses inside The Natural Veneer Blueprint™
          </figcaption>
        </figure>

        <div className="mx-auto mt-8 max-w-xl" data-id="element-194" data-mp="x14o3yhjyo90">
          <CTAButton id="hero-cta" label="Get the Natural Veneer Blueprint" note="Instant Access · One-Time Payment of $27 USD · Lifetime Access · 7-Day Guarantee" data-id="element-195" data-mp="x0crckc7ykh5" />

          <div className="mt-8" data-id="element-196" data-mp="3hpsf16g55t2k">
            <Countdown note="🔥 Get instant access at the special launch price." data-id="element-197" data-mp="3htpwlnn2mckc" />
          </div>

          <div className="mt-6" data-id="element-198" data-mp="1x7hxtje7id3i">
            <ScarcityBar data-id="element-199" data-mp="21a4t5ua36g5g" />
          </div>

          <p className="mt-4 text-center text-[12.5px] font-medium text-brand-800/65" data-id="element-200" data-mp="21b66k5ekreqc">
            💱 Currency conversion is automatically handled based on your country.
          </p>
        </div>
      </div>
    </header>;
}